<p-card>
  @if (isLoading()) {
    <igx-loader [loadingText]="'Gegevens ophalen' | translate"></igx-loader>
  } @else {
    <igx-header [title]="title()" [buttonOptions]="headerButtons()"></igx-header>

    <p-fluid class="">
      <form class="mt-5 user-form" [formGroup]="formGroup">
        <div class="user-form__section">
          <igx-text-input [valueFormControl]="formGroup.controls.firstName" [label]="'Voornaam' | translate"></igx-text-input>
          <igx-text-input [valueFormControl]="formGroup.controls.lastName" [label]="'Achternaam' | translate"></igx-text-input>
        </div>
        <div class="user-form__section">
          <igx-text-input [valueFormControl]="formGroup.controls.email" [label]="'Email' | translate"></igx-text-input>
          @if (isAdmin() && !isOwnAccount) {
            <igx-multi-select
              [valueFormControl]="formGroup.controls.roles"
              [label]="'Rollen' | translate"
              [options]="roles()"
            ></igx-multi-select>
          }
        </div>
        @if (!userId()) {
          <div class="">
            <div class="user-form__section">
              <p-fluid>
                <p-floatlabel variant="on" styleClass="text-input">
                  <p-password
                    [formControl]="formGroup.controls.password"
                    [toggleMask]="true"
                    [promptLabel]="'Geef wachtwoord in' | translate"
                    [weakLabel]="'Kies een sterker wachtwoord' | translate"
                    [mediumLabel]="'Wachtwoord kan beter' | translate"
                    [strongLabel]="'Sterk wachtwoord' | translate"
                  />

                  <label for="on_label">
                    {{ 'Wachtwoord' | translate }}
                    <span class="required-indicator">*</span>
                  </label>
                </p-floatlabel>
              </p-fluid>
              <p-fluid>
                <p-floatlabel variant="on" styleClass="text-input">
                  <p-password [formControl]="passwordRepeat" [toggleMask]="true" [feedback]="false" />

                  <label for="on_label">
                    {{ 'Herhaal wachtwoord' | translate }}
                    <span class="required-indicator">*</span>
                  </label>
                </p-floatlabel>
              </p-fluid>
            </div>
          </div>
        }
      </form>
    </p-fluid>
  }
</p-card>
